import { render, staticRenderFns } from "./SafetyRecommendations.vue?vue&type=template&id=01e427dc"
import script from "./SafetyRecommendations.vue?vue&type=script&lang=js"
export * from "./SafetyRecommendations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports